var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_Map.js
// module id = 1068
// module chunks = 3 9 13